import React, { useState, useEffect } from "react";
import Loader from "react-loader-spinner";

import Header from "./Workshop/Header";
import Synthesis from "./Workshop/Synthesis";
import Sectors from "./Workshop/Sectors";

import api from "../api/APIHandler";
import Modal from "../components/partials/Modal";
import ModalOptionsWorkshop from "../components/Workshops/ModalOptionsWorkshop";
import ModalDeleteWorkshop from "../components/Workshops/ModalDeleteWorkshop";
import Participants from "./Workshop/Participants";

import { getValuesFormatted } from "../utils/getValuesFormatted";
import { getUrl } from "../utils/getUrl";
import { computeData } from "../utils/computeData";
import "../styles/workshop_infos.css";
import { median } from "utils/median";

import { aggregatorInfos, addNonDisplayedValues } from './Workshop/config';



const WorkshopInfos = (props) => {
  // data got from the workshop api
  const [workshopDataTotal, setWorkshopDataTotal] = useState(null);
  const [workshopData, setWorkshopData] = useState(null);
  
  // initial data from the MC version used for the workshop
  // (with parameters & categories infos (colors, step, min, max....))
  const [jsonFile, setJsonFile] = useState(null);

  // data computed from workshop & json with average, median, etc.
  const [computedDatas, setComputedDatas] = useState(null);

  // true if all the sectors have been worked during workshop
  // (if not, there is no relevant complete result)
  const [results, setResults] = useState(null);

  const [indicators, setIndicators] = useState(null);

  const [medianParams, setMedianParams] = useState(null);
  const [meanParams, setMeanParams] = useState(null);
  const [missionClimatVersion, setMissionClimatVersion] = useState(null);

  const [isLoading, setIsLoading] = useState(true);
  const [url, setUrl] = useState("");
  const [page, setPage] = useState("Synthèse");
  const [sector, setSector] = useState("Habitat"); // TO DO : generic init
  const [EPCI, setEPCI] = useState("Toutes"); // TO DO : generic init

  // MODALS
  const [modalOptionsWS, setModalOptionsWS] = useState(false);
  const [modalDeleteWS, setModalDeleteWS] = useState(false);


  const id = props.match.params.id;

  // GET WORKSHOP DATA
  useEffect(() => {
    api
      .get(`/aggregator/workshop/${id}/`)
      .then((res) => {
        setWorkshopDataTotal(res.data);
        // handle case if results
        if (res.data.results.length !== 0) {
          // getMissionClimatVersion
          for (const aggregator in aggregatorInfos) {
            aggregatorInfos[aggregator]["front"].map((version) => {
              if (res.data.results[0].url.includes(version)) {
                setMissionClimatVersion(aggregator);
              }
            });
          }
        } else {
          // handle case no results yes
          setIsLoading(false);
        }
      })
      .catch((err) => console.log(err));
  }, []);

  // GET JSON DATA
  useEffect(() => {
      api
      .get("/sheet/jsonfile")
      .then((res) => {
        setJsonFile(res.data);
      })
      .catch((err) => console.log(err));
  }, []);

  //FILTER WS DATA BASED ON EPCI
  useEffect(() => {
    if (workshopDataTotal) {
      let wsDataTemp = { ...workshopDataTotal };
      if (EPCI !== "Toutes") {
        const resultsFiltered = workshopDataTotal.results.filter(result => result.EPCISelection.EPCI === EPCI)
        wsDataTemp.results = [...resultsFiltered];
      }
      setWorkshopData(wsDataTemp)
    }
  }, [workshopDataTotal, EPCI])
  
  //GET COMPUTED DATAS
  useEffect(() => {
    if (jsonFile && workshopData && workshopData.results.length > 0) {
      const computedDatasTemp = computeData(workshopData, jsonFile);
      setComputedDatas(computedDatasTemp);
      setMedianParams(computedDatasTemp.parameters.map((v) => [v.median]));
    }
  }, [jsonFile, workshopData])
  

  // GET RESULTS DATA
  useEffect(() => {
    if (medianParams && missionClimatVersion) {
      
      const medianParamsWithinAllData = jsonFile.options.vInit
      computedDatas.parameters.forEach((param, i) => {
        medianParamsWithinAllData[param.index]=medianParams[i];
      })

      const valuesFormatted = getValuesFormatted(medianParamsWithinAllData, jsonFile.options.unit);
      
      api
        .patch(`/sheet/update/${aggregatorInfos[missionClimatVersion].spreadsheetId}`, {
          values: valuesFormatted,
        })
        .then((res) => {
          const resTemp = res.data.results;
          setResults(resTemp);
          const medianParamsComplete = addNonDisplayedValues(medianParams, jsonFile)
          setUrl(getUrl(medianParamsComplete, jsonFile.parameters));
          setIsLoading(false);

          const indicatorsTemps = [];
          for (const area in resTemp.indicators) {
            for (const degree in resTemp.indicators[area]) {
              resTemp.indicators[area][degree].map((v) => indicatorsTemps.push(v));
            }
          }
          setIndicators(indicatorsTemps);
        })
        .catch((err) => console.log(err));
    }
  }, [medianParams, missionClimatVersion]);

  const handleDeleteOption = () => {
    setModalDeleteWS(true);
  }

  const handleDeleteWS = (admin_code) => {
    api
      .delete(`/aggregator/workshop/`, `${id}/?admin_code=${admin_code}`)
      .then((res) => {
      })
      .catch((err) => console.log(err));
  };

  return (
    <div id="workshop_infos" className="flex-column acenter">
      {isLoading && (
        <div id="sim_loader" className="modal-parent flex-item jcenter acenter">
          <Loader type="Oval" color="var(--mainColor)" height={100} width={100} />
        </div>
      )}

      <Modal isOpen={modalOptionsWS} closeModal={() => setModalOptionsWS(false)} cancelButton>
        <ModalOptionsWorkshop
          openDelete={handleDeleteOption}
          closeModal={() => setModalOptionsWS(false)}
          url={url}
          api={api}
          id={id}
        />
      </Modal>

      <Modal isOpen={modalDeleteWS} closeModal={() => setModalDeleteWS(false)}>
        <ModalDeleteWorkshop
          closeModal={() => setModalDeleteWS(false)}
          handleDeleteWS={handleDeleteWS}
        />
      </Modal>

      {workshopData && 
      <Header 
        workshopData={workshopData}
        setPage={setPage}
        page={page} 
        setModalOptionsWS={setModalOptionsWS}
        EPCI={EPCI} 
        setEPCI={setEPCI}
        />}

      {workshopData && workshopData.results.length === 0 ?
        <p>Aucun résultat</p>
        :
        <>
        {page === "Synthèse" &&
          <Synthesis 
            indicators={indicators} 
            computedDatas={computedDatas} 
            results={results}
            />}
          
          {page === "Secteurs" &&
            <Sectors
              computedDatas={computedDatas} 
              results={results}
              page={page} 
              sector={sector}
              setSector={setSector}
            />
          }

          {page === "Participants" && (
            <Participants
              medianParams={medianParams}
              jsonFile={jsonFile}
              computedDatas={computedDatas}
              results={results}
              id={id}
            />
          )}
        </>
      }
    </div>
  );
};

export default WorkshopInfos;
